class ToggleSubmitButtonWithSpinner {
  static execute(submitButtonSelector) {
    const submitButtonElement = document.querySelector(submitButtonSelector)
    submitButtonElement.classList.toggle('spinner')
    submitButtonElement.disabled = !submitButtonElement.disabled
  }
}

export default ToggleSubmitButtonWithSpinner
